// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\UploadMediaListResponse

import { hydrateUploadAsset, type UploadAsset, type UploadAssetApiResponse } from './uploadAsset.gen';

export type UploadMediaListApiResponse = {
	assets: UploadAssetApiResponse[];
	totalSize: number;
	maxQuota: number;
};

export type UploadMediaList = {
	assets: UploadAsset[];
	totalSize: number;
	maxQuota: number;
};

export function hydrateUploadMediaList(data: UploadMediaListApiResponse): UploadMediaList {
	return {
		...data,
		assets: data.assets.map(hydrateUploadAsset),
	};
}